import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

const styles = theme => ({
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
});

const ContentCard = ({ classes, className, cardHeight, cardWidth, contentHeight, contentWidth, title, children, style, ...rest }) => {
  return (
    <Paper className={className} style={{ margin: 8, padding: 16, ...style, height: cardHeight, width: cardWidth }} {...rest}>
      {title
        ? <>
            <Typography variant='subtitle2'>{title}</Typography>
            <Divider className={classes.divider} />
          </>
        : null
      }
      <div style={{ height: contentHeight, width: contentWidth }}>
        {children}
      </div>
    </Paper>
  )
}

export default withStyles(styles)(ContentCard);